module.exports = __webpack_public_path__ + "img/icon_production.9dcd555b.png";